module.exports = __webpack_public_path__ + "img/lastNameEle.76173905.svg";